import { createSlice } from '@reduxjs/toolkit';

export const spotlightSlice = createSlice({
  name: 'spotlight',
  initialState: {
    type: 0,
    id: 0,
  },
  reducers: {
    spotlightStore: (state, action) => {
      state.type = action.payload?.type;
      state.id = action.payload?.id;
      state.isActive = action.payload?.isActive;
    },
    spotlightUpdateType: (state, action) => {
      state.type = action.payload;
    },
    spotlightUpdateId: (state, action) => {
      state.id = action.payload;
    },
    spotlightUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
  },
});

export const { spotlightStore, spotlightUpdateType, spotlightUpdateId, spotlightUpdateIsActive } = spotlightSlice.actions;

export const selectSpotlightType = (state) => state.spotlight.type;
export const selectSpotlightId = (state) => state.spotlight.id;
export const selectSpotlightIsActive = (state) => state.spotlight.isActive;

export default spotlightSlice.reducer;
